import React from 'react';
import { X, Check } from 'lucide-react';

const WhiteGloveMeans = () => {
  return (
    <section className="py-20 px-6 bg-gray-950">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            More than onboarding — a partnership.
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Most software hands you a login and a help doc. We do the opposite: we embed with you to map your goals, tailor your system, and ensure adoption.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Typical Onboarding */}
          <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800 relative">
            <div className="absolute -top-3 -right-3 w-10 h-10 bg-red-900/30 border border-red-700 rounded-full flex items-center justify-center">
              <X className="w-5 h-5 text-red-400" />
            </div>
            <h3 className="text-2xl font-bold text-gray-400 mb-6">Typical Onboarding</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-gray-800 border border-gray-700 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 bg-gray-600 rounded-full" />
                </div>
                <span className="text-gray-400">Generic templates</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-gray-800 border border-gray-700 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 bg-gray-600 rounded-full" />
                </div>
                <span className="text-gray-400">Self-serve setup</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-gray-800 border border-gray-700 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 bg-gray-600 rounded-full" />
                </div>
                <span className="text-gray-400">You do the heavy lifting</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-gray-800 border border-gray-700 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 bg-gray-600 rounded-full" />
                </div>
                <span className="text-gray-400">Hope for the best</span>
              </li>
            </ul>
          </div>

          {/* Traain White-Glove */}
          <div className="bg-gradient-to-br from-blue-900/20 to-indigo-900/20 rounded-2xl p-8 border border-blue-700 relative shadow-[0_0_30px_rgba(59,130,246,0.2)]">
            <div className="absolute -top-3 -right-3 w-10 h-10 bg-blue-900/50 border border-blue-600 rounded-full flex items-center justify-center">
              <Check className="w-5 h-5 text-blue-400" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-6">Traain White-Glove</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Check className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-200 font-medium">We learn your business</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-200 font-medium">We build the system with you</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-200 font-medium">We coach your team to mastery</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-200 font-medium">We optimize for real results</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteGloveMeans;